import { useState } from "react";
import verifid from '../../assets/verificado.png';

const ImageGallery = ({ photos }) => {
  const [selectedMedia, setSelectedMedia] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!photos || photos.length === 0) return null;

  // Convertir objetos en un array de URLs. Suponemos que photos ya trae la URL completa (p.ej. "/media/...")
  const mediaUrls = photos.map((photo) => `${process.env.REACT_APP_API_URL}${photo.image}`);

  const goToPreviousMedia = () => {
    setSelectedMedia((prev) => (prev === 0 ? mediaUrls.length - 1 : prev - 1));
  };

  const goToNextMedia = () => {
    setSelectedMedia((prev) => (prev === mediaUrls.length - 1 ? 0 : prev + 1));
  };

  // Función para determinar si el URL corresponde a un video (basado en la extensión)
  const isVideo = (url) => {
    const lowerUrl = url.toLowerCase();
    return lowerUrl.endsWith(".webm") || lowerUrl.endsWith(".mp4") || lowerUrl.endsWith(".ogg");
  };

  // Renderiza el medio según su tipo
  const renderMedia = (url, className, onClick) => {
    if (isVideo(url)) {
      return (
        <video src={url} controls className={className} onClick={onClick} />
      );
    }
    return (
      <img src={url} alt="Product" className={className} onClick={onClick} />
    );
  };

  return (
    <div className="w-full">
      {/* Carrusel de medios */}
      <div className="relative w-full h-96 rounded-lg overflow-hidden">
        {renderMedia(
          mediaUrls[selectedMedia],
          "w-full h-full object-cover cursor-pointer",
          () => setIsModalOpen(true)
        )}
        {/* Imagen de verificación posicionada en la esquina superior derecha */}
        <img
          src={verifid}
          alt="Verificado"
          className="w-12 h-12 absolute top-4 right-4"
        />
        {/* Botón para medio anterior */}
        <button
          className="absolute top-1/2 left-4 text-white text-2xl transform -translate-y-1/2 bg-black bg-opacity-50 rounded-full p-2"
          onClick={(e) => {
            e.stopPropagation();
            goToPreviousMedia();
          }}
        >
          &#10094;
        </button>
        {/* Botón para medio siguiente */}
        <button
          className="absolute top-1/2 right-4 text-white text-2xl transform -translate-y-1/2 bg-black bg-opacity-50 rounded-full p-2"
          onClick={(e) => {
            e.stopPropagation();
            goToNextMedia();
          }}
        >
          &#10095;
        </button>
      </div>

      {/* Modal para ver el medio en grande */}
      {isModalOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50"
          onClick={() => setIsModalOpen(false)}
        >
          <div className="relative max-w-3xl max-h-full">
            {renderMedia(
              mediaUrls[selectedMedia],
              "max-w-full max-h-screen",
              () => {}
            )}
            <button
              className="absolute top-4 right-4 text-white text-2xl"
              onClick={() => setIsModalOpen(false)}
            >
              &times;
            </button>
            <button
              className="absolute top-1/2 left-4 text-white text-2xl transform -translate-y-1/2"
              onClick={(e) => {
                e.stopPropagation();
                goToPreviousMedia();
              }}
            >
              &#10094;
            </button>
            <button
              className="absolute top-1/2 right-4 text-white text-2xl transform -translate-y-1/2"
              onClick={(e) => {
                e.stopPropagation();
                goToNextMedia();
              }}
            >
              &#10095;
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageGallery;
